import { useSystemStatus } from '@/hooks/useSystemStatus';
import { useDashboardBootstrap } from '@/hooks/useDashboardBootstrap';
import { env } from '@/lib/env';
import { cn } from '@/lib/cn';

const BUILD_LABEL = 'Sprint 02 · Auth, RBAC & Tenancy';

export function SystemStatusBar() {
  const { status, isLoading } = useSystemStatus();
  const bootstrapQuery = useDashboardBootstrap();
  const online = status.reachable;
  const runtimeEnvironment = bootstrapQuery.data?.systemStatus?.environment ?? env.environment;

  return (
    <footer className="text-muted-foreground flex h-8 shrink-0 items-center justify-between border-t border-white/[0.08] bg-background/55 px-4 text-[11px] backdrop-blur-glass">
      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1.5">
          <span
            aria-hidden="true"
            className={cn(
              isLoading ? 'text-warning' : online ? 'text-success' : 'text-critical',
              online && !isLoading ? 'hx-live' : 'inline-block h-2 w-2 rounded-full bg-current',
            )}
          />
          <span className="font-medium">
            API {isLoading ? 'checking…' : online ? 'online' : 'offline'}
          </span>
        </span>
        <span className="hidden sm:inline">
          Database: <span className="text-foreground/80 font-medium">{status.database}</span>
        </span>
      </div>
      <div className="flex items-center gap-4">
        <span className="hidden md:inline">env: {runtimeEnvironment}</span>
        <span className="text-foreground/70 font-medium">{BUILD_LABEL}</span>
      </div>
    </footer>
  );
}
